import { useEffect, useState } from 'react'
import { statutsOnboarding } from '../../api/onboarding'
import type { StatutOnboarding } from '../../api/onboardingRegles'
import { BadgeOnboarding } from './Briques'

/**
 * Pour l'écran « Clients » : statut d'onboarding de chaque PME (lu à part, pour ne pas toucher au chargement
 * général de la console). `version` : changer sa valeur relit les statuts (après création ou rafraîchissement).
 * Illisible = carte vide : la colonne reste vide, jamais bloquante.
 */
export function useStatutsOnboarding(orgId: string, version: unknown): Map<string, StatutOnboarding> {
  const [m, setM] = useState<Map<string, StatutOnboarding>>(new Map())
  useEffect(() => {
    let vivant = true
    if (orgId === 'apercu') return
    void statutsOnboarding(orgId).then((r) => { if (vivant) setM(r) })
    return () => { vivant = false }
  }, [orgId, version])
  return m
}

/** Cellule « Onboarding » : le badge, et « Démarrer l'onboarding » tant que le dossier n'est pas ouvert. */
export function CelluleOnboarding({
  statut,
  peutGerer,
  surOuvrir,
}: {
  statut: StatutOnboarding | undefined
  peutGerer: boolean
  surOuvrir?: (() => void) | undefined
}) {
  if (!statut) return <span className="t-muted">—</span>
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'flex-start' }}>
      <BadgeOnboarding statut={statut} />
      {surOuvrir && (
        <button className="btn btn-ghost btn-sm" style={{ padding: '3px 8px', fontSize: 11.5 }} onClick={surOuvrir}>
          {statut === 'prospect' && peutGerer ? 'Démarrer l’onboarding' : 'Voir le dossier'}
        </button>
      )}
    </div>
  )
}
